<template>
    <v-app-bar
            app
            color="#e99922"
            dark
            fixed
            dense
            max-width="100vw"
    >
        <v-toolbar-title>
            <v-img
                    alt="Ludi Health"
                    class="shrink"
                    contain
                    src="@/assets/logo_banner.png"
                    transition="scale-transition"
                    height="48px"
                    position="0% 50%"
                    @click="$router.push({name:'home'})"
                    style="cursor: pointer"
                    max-width="230px"
            />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="$vuetify.breakpoint.mdAndUp">
            <v-btn
                    text
                    :to="{name:'ourevent'}"
            >
                <span class="mr-2">Notre événement</span>
                <v-icon>mdi-menu-right</v-icon>
            </v-btn>
            <v-btn
                    text
                    :to="{name:'subscribe'}"

            >
                <span class="mr-2">S'inscrire</span>
                <v-icon>mdi-menu-right</v-icon>
            </v-btn>
            <v-btn
                    text
                    class="white"
                    color="#e99922"
                    :to="{name:'help'}"
            >
                <span class="mr-2"><v-icon>mdi-heart-circle-outline</v-icon> Nous aider</span>
                <v-icon>mdi-menu-right</v-icon>
            </v-btn>
        </div>
        <v-btn href="https://www.facebook.com/ludihealth" icon target="_blank" color="white">
            <v-icon>mdi-facebook-box</v-icon>
        </v-btn>
        <v-btn href="https://www.messenger.com/t/ludihealth" icon target="_blank" color="white">
            <v-icon>mdi-facebook-messenger</v-icon>
        </v-btn>
        <v-menu
                right
                dark
                color="light-blue accent-4"
        >
            <template v-slot:activator="{ on }">
                <v-btn dark text v-on="on" icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list color="light-blue accent-4">
                <v-subheader>Ludi-Health</v-subheader>
                <v-list-item link exact
                             v-for="link in links"
                             :key="link.name"
                             :to="{name:link.to}"
                >
                    <v-list-item-title>{{ link.name }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

    </v-app-bar>
</template>

<script>
    import Menu from "./Menu";
    import ContactUs from "./ContactUs";

    export default {
        name: "NavigationBar",
        components: {ContactUs},
        data() {
            return {
                links: [{name: "Accueil", to: 'home'},
                    {name: "Nous aider", to: 'help'},
                    {name: "Notre événement", to: 'ourevent'},
                    {name: "Qui sommes nous ?", to: 'aboutus'},
                    {name: "S'inscrire", to: 'subscribe'},
                ]
            }
        }
    }
</script>

<style scoped>

</style>